import { css } from '@emotion/react';
import { ReactNode } from 'react';

import { formatDate, formatDateRelative } from 'utils/formatDate';

export function TimestampValue({ iso }: { iso: string | null | undefined }) {
  if (!iso) {
    return '—';
  }

  return (
    <span title={iso}>
      {formatDate(iso)}
      <span
        css={css`
          color: #888;
          margin-left: 8px;
        `}
      >
        {formatDateRelative(iso)}
      </span>
    </span>
  );
}

export default function DetailMeta({ rows }: { rows: { label: string; value: ReactNode }[] }) {
  return (
    <dl
      css={css`
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 6px 16px;
        margin: 0 12px 16px;
        font-size: 14px;
        line-height: 1.4;

        dt {
          color: #666;
          font-size: 12px;
          letter-spacing: 0.04em;
          text-transform: uppercase;
        }

        dd {
          margin: 0;
          font-variant-numeric: tabular-nums;
        }
      `}
    >
      {rows.map((row) => (
        <div
          key={row.label}
          css={css`
            display: contents;
          `}
        >
          <dt>{row.label}</dt>
          <dd>{row.value}</dd>
        </div>
      ))}
    </dl>
  );
}
